import HeaderWelcome from '../../components/sections/HeaderWelcome'
import Landing from '../../components/sections/Landing'
import './welcome.css'

const Welcome = () => {
  return (
    <>
      <HeaderWelcome />
      <Landing />
    </>
  )
}

export default Welcome

